'use client';

import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import ShowMoreButton from '@alltrails/layout/components/ShowMoreButton/ShowMoreButton';
import { PointOfInterest } from '@/types/locationDetailsPages/shared';
import SectionHeader from '../SectionHeader';
import TopSightCard from './TopSightCard';
import styles from './TopSights.module.scss';

type TopSightsProps = {
  pointsOfInterest: PointOfInterest[];
  isBot?: boolean;
};

const MOBILE_TOP_SIGHTS_LIMIT = 3;
const MAX_TOP_SIGHTS_LIMIT = 6;

const TopSights = ({ pointsOfInterest, isBot }: TopSightsProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isMobile = useIsMobileSizedScreen();

  if (!pointsOfInterest.length) {
    return null;
  }

  const shouldShowLimitedMobileExperience = pointsOfInterest.length > MOBILE_TOP_SIGHTS_LIMIT && !isBot && isMobile;

  const firstGroup = pointsOfInterest.slice(0, MOBILE_TOP_SIGHTS_LIMIT);
  const secondGroup = pointsOfInterest.slice(MOBILE_TOP_SIGHTS_LIMIT, MAX_TOP_SIGHTS_LIMIT);

  const shouldShowSecondGroup = !shouldShowLimitedMobileExperience || isExpanded;
  const groupsToRender = shouldShowSecondGroup ? [firstGroup, secondGroup] : [firstGroup];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <SectionHeader title={<FormattedMessage defaultMessage="Top sights" />} />
      </div>
      <div className={styles.cardGroupingsContainer}>
        {groupsToRender.map((group, groupIndex) => (
          <div className={styles.cardGrouping} key={groupIndex}>
            {group.map(poi => (
              <TopSightCard key={poi.name} poi={poi} isBot={isBot} />
            ))}
          </div>
        ))}
      </div>
      {shouldShowLimitedMobileExperience && <ShowMoreButton isExpanded={isExpanded} onToggle={() => setIsExpanded(!isExpanded)} />}
    </div>
  );
};

export default TopSights;
